export function getLinkText(title: string | null, url: string) {
    let linkText = title;
    const hostname = new URL(url).hostname;
    const domain = hostname.replace(/^www\./, "");
    const lowestLevelDomain = domain.split(/[.-_]/)[0];

    if (linkText) {
        const lowerLinkText = linkText.toLocaleLowerCase();
        const isWordInLinkTextIncludedInDomain = lowerLinkText
            .split(" ")
            .some(t => lowestLevelDomain.includes(t));

        const isPartOfDomainIncludedInLinkText = lowestLevelDomain
            .split(".")
            .some(d => lowerLinkText.includes(d));

        if (
            isWordInLinkTextIncludedInDomain ||
            isPartOfDomainIncludedInLinkText ||
            (domain in allowedCombination &&
                lowerLinkText.includes(allowedCombination[domain]))
        ) {
            return linkText;
        }
    }

    return domain.length > 27 ? domain.slice(0, 27) + "..." : domain;
}

const allowedCombination = {
    "wa.me": "whatsapp",
} as {
    [key: string]: string;
};
